import { uuid } from '../../api/client';

const prefix = 'steos:history:delivery:';
function storageKey(owner: number, order: number, revision: number, format: string) {
  if (![owner, order, revision].every(value => Number.isSafeInteger(value) && value > 0) || !/^[a-z_]{1,24}$/.test(format))
    throw new Error('delivery_intent_invalid');
  return `${prefix}${owner}:${order}:${revision}:${format}`;
}
export function deliveryIntent(owner: number, order: number, revision: number, format: string): { storageKey: string; key: string } {
  const name = storageKey(owner, order, revision, format);
  try {
    const existing = sessionStorage.getItem(name);
    if (existing) {
      if (!/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(existing))
        throw new Error('delivery_intent_storage_unavailable');
      return { storageKey: name, key: existing };
    }
    const key = uuid();
    // Сохраняем намерение ДО POST. Неизвестный исход переживает размонтирование и перезагрузку вкладки.
    sessionStorage.setItem(name, key);
    if (sessionStorage.getItem(name) !== key) throw new Error('delivery_intent_storage_unavailable');
    return { storageKey: name, key };
  } catch {
    throw new Error('delivery_intent_storage_unavailable');
  }
}
export function clearDeliveryIntent(intent: { storageKey: string; key: string }) {
  try {
    if (sessionStorage.getItem(intent.storageKey) === intent.key) sessionStorage.removeItem(intent.storageKey);
  } catch {
    /* Подтверждённая доставка останется идемпотентной при повторной проверке. */
  }
}
